import React from "react";
import { Portfolio, Seo } from "../components";
import { PAGE_SEO } from "../common";

export const PortfolioPage = () => {
  return (
    <>
      <Seo {...PAGE_SEO.gallery} />
      <Portfolio />
    </>
  );
};
